<template>
	<a-col :span="24" class="chartBox">
		<a-col :span='24' class="titleBox">
			<a-col :span='4' class="left">统计图表</a-col>
			<a-col :span='20' class="right">
				<a-popconfirm placement="bottomLeft" title="是否确定一键还原?" ok-text="确定" cancel-text="我再想想" @confirm="onDefault">
					<!--<a-badge status="processing"/>-->
					<a-button :disabled='dataList.length == 0 || loading' type="primary" ghost>一键还原</a-button>
				</a-popconfirm>
				<a-button :disabled='dataList.length == 0 || loading' type="primary" class="btn" @click="updateChartView()">预览</a-button>
			</a-col>
		</a-col>
		<a-col :span='24' class="optionBox">
			<a-col :span="24">
				<span class='label'>柱状图统计项：</span>
				<a-radio-group name="radioGroup" :value="curBarChart" @change="onChangeBar">
					<template v-for="(item, index) in barCharts">
						<div :key="index" class="checkItemBox">
							<a-radio :disabled="!item.isShow" :value="item.column">{{ item.axisTitle }}</a-radio>
						</div>
					</template>
				</a-radio-group>
			</a-col>
			<a-col :span="24">
				<span class='label'>折线图统计项：</span>
				<template v-for="(item, index) in lineCharts">
					<div :key="index" class="checkItemBox">
						<a-checkbox :disabled="!item.isShow" v-model="item.checked" @change="onChangeLine">{{ item.axisTitle }}</a-checkbox>
						<a-select :disabled="!item.isShow" size="small" v-model="item.position" @change="onChangePosition">
							<a-select-option value="left">左</a-select-option>
							<a-select-option value="right">右</a-select-option>
						</a-select>
					</div>
				</template>
			</a-col>
		</a-col>
		<a-col :span="24" id="chartWrapper"></a-col>
	</a-col>
</template>

<script>
	import echarts from 'echarts';
	import barCharts from './barCharts.json';
	import lineCharts from './lineCharts.json';
	export default {
		props: {
			// 列表查询的数据
			dataList: {
				type: Array,
				default: () => []
			},
			// 数据是否正在请求中
			loading: {
				type: Boolean,
				default: false
			}
		},
		watch: {
			loading() {
				if(!this.loading) {
					this.updateChartView()
				} else {
					this.initEChartView();
				}
			}
		},
		computed: {
			// 当前选择柱状图主系
			curBarChart() {
				return this.barCharts.find(e => e.checked).column
			}
		},
		data() {
			return {
				myChart: undefined,
				barCharts: JSON.parse(JSON.stringify(barCharts)), // 柱状图配置项
				lineCharts: JSON.parse(JSON.stringify(lineCharts)) // 折线图配置项
			}
		},
		mounted() {
			this.initEChartView();
		},
		methods: {
			// 一键还原
			onDefault() {
				this.barCharts = JSON.parse(JSON.stringify(barCharts));
				this.lineCharts = JSON.parse(JSON.stringify(lineCharts));
				this.updateChartView();
			},
			// 选择柱状图
			onChangeBar(event) {
				// 选择当前的柱状图主系
				this.barCharts.map(e => {
					if(event.target.value == e.column) {
						e.checked = true
					} else {
						e.checked = false
					}
				})
				// 被选择的状态图主系，折线图对应要互斥取消
				this.lineCharts.map(e => {
					if(event.target.value == e.column) {
						e.checked = false;
						e.isShow = false;
					} else {
						e.isShow = true;
					}
				})
				this.updateChartView()
			},
			// 选择折线图
			onChangeLine(event) {
				this.barCharts.map(e => {
					if(event.target.value == e.column) {
						e.checked = false
					}
				})
				this.updateChartView()
			},
			// 选择Y轴
			onChangePosition() {
				this.updateChartView()
			},
            // 新报表--导出excel的维度配置项
            updateSeries() {
                const series = [{
					title: "订车人花费排序",
					barCharts: this.barCharts.filter(e => e.checked).map(ele => {
						return {
							column: ele.column,
							axisTitle: ele.axisTitle,
							position: ele.position
						}
					}),
					lineCharts: this.lineCharts.filter(e => e.checked).map(ele => {
						return {
							column: ele.column,
							axisTitle: ele.axisTitle,
							position: ele.position
						}
					})
				}]
                this.$store.commit("SETSERIES", series)
            },
			// 更新chart
			updateChartView() {
                this.updateSeries();
				this.myChart.clear() // 清空缓存，在修改chart时必须这么做，否则错乱
				this.myChart.hideLoading();
				const options = {
					// 主题
					title: {
						text: '订车人花费排序'
					},
					// 头部控制显示隐藏当前状图
					legend: {
						data: [
							...this.barCharts,
							...this.lineCharts
						].filter(e => e.checked).map(e => e.axisTitle)
					},
					// 显示下载保存为图片
					toolbox: {
						show: true,
						feature: {
							dataView: {
								readOnly: false
							},
							restore: {},
							saveAsImage: {}
						}
					},
					// 显示对齐的轴线
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'cross',
							label: {
								backgroundColor: '#283b56'
							}
						}
					},
					// x轴线
					xAxis: {
						type: 'category',
						data: this.dataList.map(ele => ele.DspName)
					},
					// y轴线
					yAxis: [{
						name: [
							...this.barCharts,
							...this.lineCharts
						].filter(e => e.checked && e.position == "left").map(e => e.axisTitle).join("/"),
						type: "value"
					}, {
						name: [
							...this.barCharts,
							...this.lineCharts
						].filter(e => e.checked && e.position == "right").map(e => e.axisTitle).join("/"),
						type: "value"
					}],
					//						color: ['#9BBB59', '#F79646'],
					color: this.lineCharts.filter(e => e.checked).map(e => e.color),
					dataZoom: [{ // 这个dataZoom组件，默认控制x轴。
						type: 'slider', // 这个 dataZoom 组件是 slider 型 dataZoom 组件
						//							start: 10, // 左边在 10% 的位置。
						//							end: 60, // 右边在 60% 的位置。
						startValue: 0, // 如果设置了 dataZoom-inside.start 则 startValue 失效。
						endValue: 10, // 如果轴的类型为 category，则 startValue 既可以设置为 axis.data 数组的 index，也可以设置为数组值本身。 但是如果设置为数组值本身，会在内部自动转化为数组的 index
					}, {
						type: 'inside'
					}],
					//						// 状图数据配置项
					series: (() => {
						let leftChart = this.barCharts.filter(e => e.checked).map(ele => {
							return {
								name: ele.axisTitle, // y轴title
								type: 'bar', // 状图类型【柱状图】
								yAxisIndex: ele.position == 'left' ? 0 : 1, // 数据挂载的y轴位置，默认左边为0
								label: {
									show: true, // 是否列标签数据
									color: ele.color
									// formatter: '自定义列标签的文字'
								},
								itemStyle: {
									color: ele.color // 状图颜色
								},
								data: this.dataList.map(e => e[ele.column]) // 数据源
							}
						})
						let rightChart = this.lineCharts.filter(e => e.checked).map(ele => {
							return {
								name: ele.axisTitle, // y轴title
								type: 'line', // 状图类型【柱状图】
								yAxisIndex: ele.position == 'left' ? 0 : 1, // 数据挂载的y轴位置，默认左边为0
								label: {
									show: true, // 是否列标签数据
									color: ele.color
									// formatter: '自定义列标签的文字'
								},
								lineStyle: {
									color: ele.color // 状图颜色
								},
								data: this.dataList.map(e => e[ele.column]) // 数据源
							}
						})
						return [...leftChart, ...rightChart];
					})()
				}
				this.myChart.setOption(options)
            },
            // 初始化chart
			initEChartView() {
				this.myChart = echarts.init(document.getElementById('chartWrapper'));
				this.myChart.showLoading();
            },
		}
	}
</script>

<style scoped="scoped" lang="scss">
	.chartBox {
		margin-top: 16px;
		width: 100%;
		.titleBox {
			padding-bottom: 10px;
			border-bottom: 1px dashed #bfcbd9;
			margin-bottom: 15px;
			.right {
				text-align: right;
				.btn {
					width: 120px;
					margin-left: 16px;
				}
			}
		}
		.optionBox {
			padding: 16px;
			.label {
				margin-right: 16px;
			}
			.checkItemBox {
				display: inline-block;
				margin-right: 16px;
			}
		}
		#chartWrapper {
			width: 100%;
			height: 400px;
		}
	}
</style>